import React, { useCallback } from 'react'
import { FormattedHTMLMessage, Modal } from '@web/walter-ui-kit'
import Content from './Content'
import { lang } from './lang'
import { Transaction } from '~pages/CardsPage/Cards/Transactions/types'

interface Props {
    isOpen: boolean
    onRowClick: (tx: Transaction) => void
    onClose: () => void
    initCardId?: string
}

function ApprovalModal({ isOpen, onRowClick, onClose, initCardId }: Props) {
    const onRowClickCb = useCallback(
        (tx: Transaction) => {
            onClose()
            onRowClick({ ...tx })
        },
        [onClose, onRowClick]
    )

    return (
        <Modal
            title={<FormattedHTMLMessage {...lang.title} />}
            withHeaderBorder
            onClose={onClose}
            isOpen={isOpen}
            dataPointer="approve_modal"
            withContentPaddings={false}
            size="s"
            type="dialog"
        >
            <Content onRowClick={onRowClickCb} initCardId={initCardId} />
        </Modal>
    )
}

export default ApprovalModal
